import API from '@/views/Fdc/Apis/'
import _ from 'lodash'

/**
 * Data Collection > Context Mapping Plan
 * Context Mapping Plan 관리
 */
export default {
  name: 'ContextCollectionPlan',
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  watch: {
    /**
     * Context Mapping Plan row data 변화 감지
     */
    contextRowData: function () {
      this.updateComboBoxInGrid()
    }
  },
  beforeMount () {
    this.getCodeList('contextType')
  },
  mounted () {
    /**
     * Data Collection Plan에서 화면 연동 시 데이터 처리
     */
    let params = this.$route.query

    if (params.fab && params.eqpId && params.planName) {
      this.nodeObj = this.$route.query
      // this.selectedTreeNode.detail = params
      this.searchTreeNode.detail = params

      // this.searchProcess()
      this.searchToLink(params.fab, params.eqpId, params.planName)
      // this.searchDataCollectionPlanList(params.fab, params.eqpId)
    }
  },
  methods: {
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Data Collection Plan 검색
     */
    searchProcess () {
      this.dcRowData = []
      this.contextRowData = []

      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.eqpId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.searchDataCollectionPlanList(node.detail.fab, node.detail.eqpId)
    },
    /**
     * Data Collection Plan에서 연동 시 조회하는 method
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} planName Plan Name
     */
    async searchToLink (fab, eqpId, planName) {
      this.dcRowData = []
      this.contextRowData = []

      let payload = {
        fab: fab,
        eqpId: eqpId
      }

      API.Collection.getSyncCollectionPlans(payload)
        .then(response => {
          this.dcRowData = response.data

          const findItem = this.dcRowData.find(function (item) { return _.isEqual(item.planName, planName) })
          if (findItem !== null && findItem !== undefined) {
            setTimeout(() => {
              // const rowIndex = this.dcPlanGrid.collectionView.items.indexOf(findItem)
              // this.dcPlanGrid.select(rowIndex, 1)
              // this.dcPlanGrid.focus()
              this.$refs.dcPlanGrid.setFirstRowSelected()
            }, 100)
          }
        })
    },
    /**
     * Data Collection Plan 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     */
    async searchDataCollectionPlanList (fab, eqpId) {
      let payload = {
        fab: fab,
        eqpId: eqpId
      }
      let data = await API.Collection.getCollectionPlans(payload)
      this.dcRowData = data
      // this.dcOrgData = data
    },
    /**
     * Context Mapping Plan 목록 조회
     * @param {*} fab Fab
     * @param {*} eqpId EQP ID
     * @param {*} planName Plan Name
     */
    async searchContextPlanList (fab, eqpId, planName) {
      this.contextRowData = []

      let payload = {
        fab: fab,
        eqpId: eqpId,
        planName: planName
      }

      let contextData = await API.Collection.getContextPlans(payload)
      this.contextRowData = _.clone(contextData)
    },
    /**
     * Context Mapping Plan Grid에 check된 row count 확인
     * @returns {*} check된 row가 있는지 여부
     */
    hasCheckedContextRows () {
      if (!this.$refs.contextPlanGrid) {
        return 0
      }
      return this.$refs.contextPlanGrid.checkedRowCount > 0
    },
    /**
     * Refresh Button 활성화 여부 결정
     * @returns {Boolean} Refresh Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Refresh Button 활성화 여부를 결정합니다.
     */
    existRowsContextPlan () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        // if (selectEqpVo.fab !== null && selectEqpVo.eqpId !== null && this.dcPlanGrid.selectedItems !== null && this.dcPlanGrid.selectedItems.length > 0) {
        if (selectEqpVo.fab !== null && selectEqpVo.eqpId !== null && this.$refs.dcPlanGrid.gridApi.getSelectedRows() !== null && this.$refs.dcPlanGrid.gridApi.getSelectedRows().length > 0) {
          return true
        }
        return false
      }
    },
    // newRowAddContextPlan () {
    //   let selectEqpVo = this.searchTreeNode.detail
    //   let arr = [
    //     {
    //       fab: selectEqpVo.fab,
    //       eqpId: selectEqpVo.eqpId,
    //       planNme: this.dcPlanGrid.selectedItems[0].planName
    //       // createUser: this.user.userId,
    //       // modifyUser: this.user.userId
    //       // isNew: true
    //     }
    //   ]
    //   this.$refs.contextPlanGrid.addRows(arr)
    // },
    /**
     * Context Mapping Plan 재조회
     */
    refreshContextPlanGrid () {
      this.contextRowData = []
      const selectedItems = this.$refs.dcPlanGrid.gridApi.getSelectedRows()
      if (this.searchTreeNode &&
        selectedItems !== null && selectedItems.length > 0) {
        let selectEqpVo = this.searchTreeNode.detail
        // console.log(selectEqpVo)
        // console.log(this.dcPlanGrid.selectedItems)
        if (selectedItems[0] !== null) {
          this.searchContextPlanList(selectEqpVo.fab, selectEqpVo.eqpId, selectedItems[0].planName)
          // console.log(this.dcPlanGrid.selectedItems[0].planName)
        }
      }
    },
    /**
     * Context Mapping Plan 저장
     */
    async saveContextPlan () {
      const self = this
      // const allRows = this.$refs.contextPlanGrid.getAllRows() // this.$refs.contextPlanGrid.rows
      const checkedRows = this.$refs.contextPlanGrid.getCheckedRows() // this.$refs.contextPlanGrid.checkedRows
      const totalModifiedRows = this.$refs.contextPlanGrid.getUpdatedRows() // this.$refs.contextPlanGrid.totalModifiedRows
      let saveRows = []

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
        return
      }
      // let modifiedRows = this.$refs.dcPlanGrid.modifiedRows
      // let addedRows = this.$refs.dcPlanGrid.addedRows

      // allRows.some(row => {
      checkedRows.some(row => {
        // const rowStatus =  row.dataItem._status
        // 변경되어 선택된 저장 대상
        // if (rowStatus.checked && (rowStatus.added || rowStatus.modified)) {
        if (row.briqueGridCud && row.briqueGridCud === 'U') {
          const item = _.clone(row) // _.clone(row.dataItem)
          // delete item['_status']
          saveRows.push(item)
        }
      })

      // 변경된 데이터가 없다.
      if (saveRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
        return
      }

      let confirmMessage = ''
      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')
      if (!_.isEqual(saveRows.length, totalModifiedRows.length)) {
        confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
      }
      confirmMessage += 'TOTAL ' + checkedRows.length + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_SAVE')

      if (this.saveValidationCheck(saveRows) === false) {
        return
      }

      let payload = saveRows

      this.$dialog.confirm({
        message: confirmMessage,
        onConfirm: async function () {
          const responseData = await API.Collection.addContextPlans(payload)
          if (responseData != null && responseData.status === 200) {
            self.$dialog.alert(successMessage)
            // self.dcRowData.forEach(row => {
            //   // row['_status'].added = false
            //   // row['_status'].checked = false
            //   // row['_status'].modified = false
            // })
            // self.contextPlanGrid.collectionView.refresh()
            self.refreshContextPlanGrid()
          } else {
            self.$dialog.alert(failMessage)
          }
        }
        // onCancel: function () {}
      })
    },
    /**
     * Context Mapping Plan Save Validation
     * @param {Array} rows grid row 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidationCheck (rows) {
      for (let i in rows) {
        if (!rows[i].fab || rows[i].fab.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['FAB']))
          return false
        } else if (!rows[i].eqpId || rows[i].eqpId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['EQP ID']))
          return false
        } else if (!rows[i].planName || rows[i].planName.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['PLAN NAME']))
          return false
        }
      }
      return true
    },
    // /**
    //  * Context Mapping Plan 삭제
    //  */
    // async deleteContextPlan () {
    //   const that = this
    //   const checkedRows = []
    //   const allRows = this.$refs.contextPlanGrid.rows
    //   let addedRow = []
    //   let deleteRow = []

    //   allRows.some(row => {
    //     const rowStatus = row.dataItem._status
    //     if (rowStatus.checked) {
    //       checkedRows.push(row.dataItem)
    //       if (rowStatus.added) {
    //         addedRow.push(row.dataItem)
    //       } else {
    //         const item = _.clone(row.dataItem)
    //         delete item['_status']
    //         deleteRow.push(item)
    //       }
    //     }
    //   })

    //   if (checkedRows < 1) {
    //     this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
    //   }

    //   const confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE', [checkedRows.length])
    //   const completeMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')

    //   let payload = deleteRow

    //   this.$dialog.confirm({
    //     message: confirmMessage,
    //     onConfirm: async function () {
    //       if (deleteRow.length > 0) {
    //         await API.FdcCollectionPlan.deleteContextCollectionPlan(payload)
    //       }
    //       checkedRows.forEach(element => {
    //         that.contextPlanGrid.collectionView.remove(element)
    //       })
    //       that.contextPlanGrid.collectionView.refresh()
    //       that.$dialog.alert(completeMessage)
    //     }
    //   })
    // },
    /**
     * Context Mapping Plan grid dataMap 설정 (context typw)
     */
    // updateComboBoxInGrid () {
    //   if (this.contextPlanGrid) {
    //     let colContextType = this.contextPlanGrid.columns.getColumn('contextType')
    //     if (colContextType) {
    //       colContextType.dataMapEditor = true
    //       colContextType.dataMap = this.buildDataMap(this.contextTypeList)
    //     }
    //   }
    // },
    updateComboBoxInGrid () {
      this.contextColumns.map(c => {
        if (c.field === 'contextType') {
          c.cellEditor = 'agSelectCellEditor'
          c.cellEditorParams = {
            values: this.contextTypeList
          }
        }
        return c
      })
      this.$refs.contextPlanGrid.gridApi.setColumnDefs(this.contextColumns)
    },
    /**
     * 코드 목록 조회
     * @param {String} type code type
     */
    async getCodeList (type) {
      // var data = await API.FdcCollectionPlan.codeList(type)
      var payload = {
        codeType: type
      }
      var data = await API.Common.getCodesString(payload)
      if (type === 'contextType') {
        this.contextTypeList = data
      }
    },
    /**
     * BRIQUE grid selection change event
     * @param {*} rows selection rows
     */
    gridSelectionChanged (rows) {
      if (rows.length === 1) {
        var currentRow = rows[0]
        let node = this.selectedTreeNode
        if (node != null) {
          if (currentRow.planName != null) {
            // console.log(node.detail.fab, node.detail.eqpId, currentRow.planName)
            this.searchContextPlanList(node.detail.fab, node.detail.eqpId, currentRow.planName)
          }
        }
      } else {
        // TODO: 처리 필요시 추가
      }
    }
  },
  data () {
    return {
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true,
        editable: false
      }, // BRIQUE Grid column default setting
      dcColumns: [
        { headerName: this.$t('fdc.COMMON.COLUMN.PLAN_NAME'), field: 'planName', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.IDLE_APPLY'), field: 'idleApplyYn', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_TIMEOUT'), field: 'lotTimeout', width: 120, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_TIMEOUT'), field: 'substTimeout', width: 130, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRACE_TIMEOUT'), field: 'traceTimeout', width: 130, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.TARGET'), field: 'targetId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SOURCE'), field: 'sourceId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TARGET_URL'), field: 'targetUrl', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_CMD'), field: 'eventCmd', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRACE_CMD'), field: 'traceCmd', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.REQUEST_URL'), field: 'requestUrl', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.REPLY_URL'), field: 'replyUrl', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 180, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ], // Data Collection Plan grid column 배열
      contextColumns: [
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_NAME'), field: 'contextName', width: 150, required: true, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_TYPE'), field: 'contextType', width: 150, required: true, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_KEY'), field: 'contextKey', width: 180, required: true, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_INDEX'), field: 'contextIndex', width: 120, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CONTEXT_DATA'), field: 'contextData', width: 300, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 180, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ], // Context Mapping Plan grid column 배열
      dcRowData: [], // Data Collection Plan row data
      contextRowData: [], // Context Mapping Plan row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색한 EQP Tree node
      // collectionViewOptions: {
      //   // groupDescriptions: ['eqpId']
      // }, // Context Mapping Plan grid collectionView Option
      dcSelRowIdx: -1, // Data Collection Plan select row index
      nodeObj: null, // Data Collection Plan에서 화면 연동시 저장된 EQP Tree node 정보
      contextTypeList: [] // Context Type 배열
    }
  }
}
